import StatusBadge from 'components/atoms/status-badge'
import { RETURN_TYPE } from 'domains/seller-outbound-return/constants'
import PropTypes from 'prop-types'
import React from 'react'


const propTypes = {
  return_type: PropTypes.string
}


/**
 * To give nice look on Consignor Return `return_type`.
 * It maps `return_type` to certain style and pass to `return_type`.
 * @param {string} return_type Consignor Return `return_type`. available values
 * - `aged`
 * - `donated`
 * - `refunded`
 * - `rejected`
 * - `seller_requested`
 * - `banned`
 */
const SellerOutboundReturnTypeBadge = ({ return_type }) => {
  const colorMap = {
    [RETURN_TYPE.AGED]             : 'success',
    [RETURN_TYPE.DONATED]          : 'info',
    [RETURN_TYPE.REFUNDED]         : 'warning',
    [RETURN_TYPE.REJECTED]         : 'danger',
    [RETURN_TYPE.SELLER_REQUESTED]     : 'primary',
    [RETURN_TYPE.BANNED]               : 'danger',
    [RETURN_TYPE.CONSIGNMENT_EXPIRED]  : 'success',
    [RETURN_TYPE.SOLD_BY_CONSIGNOR]    : 'primary',
    [RETURN_TYPE.ABOVE_MARKET_PRICE]   : 'warning',
    [RETURN_TYPE.TEMPORARY_WITHDRAWAL] : 'info',
    [RETURN_TYPE.ITEM_UNIDENTIFIED]    : 'danger',
    [RETURN_TYPE.BELOW_FAIR_CONDITION] : 'warning'
  }

  const color = colorMap[return_type] || 'default'

  return <StatusBadge color={ color } label={ return_type } />
}

SellerOutboundReturnTypeBadge.propTypes = propTypes

export default SellerOutboundReturnTypeBadge
